import { motion } from "framer-motion";
import { Award, Trophy } from "lucide-react";
import { useAchievements } from "@/hooks/usePortfolio";
import { SectionTitle } from "@/components/SectionTitle";

export const Achievements = () => {
  const { data: achievements, isLoading, error } = useAchievements();

  if (isLoading || error || !achievements) return null;
  const sortedAchievements = [...achievements].sort((a,b) => a.displayOrder - b.displayOrder);

  return (
    <section id="achievements" className="section-pad relative" data-testid="achievements-section">
      <div className="container-x">
        <SectionTitle eyebrow="Honors" title={<>Awards & <span className="italic gold-text">achievements</span></>} subtitle="Recognition earned across employers, regions and roles — a record of consistent excellence." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {sortedAchievements.map((a, i) => (
            <motion.div
              key={a.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: i * 0.03 }}
              data-testid={`achievement-${a.id}`}
              className="group relative rounded-2xl glass grain overflow-hidden hover:border-[hsl(var(--gold))]/50 transition-all"
            >
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[hsl(var(--gold-light))]/20 to-[hsl(var(--gold-deep))]/20 border border-[hsl(var(--gold))]/30 flex items-center justify-center">
                    {i < 3 ? <Trophy className="w-5 h-5 text-[hsl(var(--gold-deep))] dark:text-[hsl(var(--gold-light))]" /> : <Award className="w-5 h-5 text-[hsl(var(--gold-deep))] dark:text-[hsl(var(--gold-light))]" />}
                  </div>
                  {a.achievementDate && (
                    <span className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mt-2">{new Date(a.achievementDate).getFullYear()}</span>
                  )}
                </div>
                <h3 className="font-serif text-lg leading-snug">{a.title}</h3>
                <div className="mt-2 text-xs uppercase tracking-[0.2em] text-[hsl(var(--gold-deep))] dark:text-[hsl(var(--gold-light))]">{a.issuer}</div>
                <p className="mt-3 text-sm text-muted-foreground text-justify-luxury">{a.description}</p>
              </div>
              <div className="absolute -bottom-12 -right-12 w-32 h-32 rounded-full bg-[hsl(var(--gold))]/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
